import styled from "styled-components"

export const StyledHeader = styled.header`
  height: 100px;
  width: 100%;
  grid-column: 1 / span 2;
  display: flex;
  align-items: center;
  justify-content: center;

  & > a {
    text-decoration: none;
  }

  @media (max-width: 992px) {
    grid-column: 1 / span 1;
  }
`
